import React, { useState } from 'react';
import classNames from 'classnames';
import { View } from '@uncinc/react-drupal-core';

const ParagraphBlockReference = ({ entity, className }) => {
  const classes = classNames('Paragraph ParagraphBlockReference', className);
  const [blockType, blockId] = entity.getIn(['field_block_reference', 0, 'value']).split('__');
  const [currentPage, setCurrentPage] = useState(0);

  // We only support view blocks for now.
  if (blockType === 'views_block') {
    // eslint-disable-next-line prefer-const
    const [viewId] = blockId.split('_', 1);
    const viewDisplay = blockId.replace(`${viewId}_`, '');

    return (
      <div className={classes}>
        <div className="ParagraphBlockReference__view">
          <View id={viewId} display={viewDisplay} page={currentPage} setCurrentPage={setCurrentPage} />
        </div>
      </div>
    );
  }

  return (
    <div className={classes}>
      <p>Block id: {entity.getIn(['field_block_reference', 0, 'value'])}</p>
    </div>
  );
};

export default ParagraphBlockReference;
